module.exports = __webpack_public_path__ + "static/media/chart.3b523afe.svg";